import React from "react";
import {
    FaLinkedin,
    FaGithub,
    FaTwitter,
    FaEnvelope,
    FaPhone,
    FaFacebook
} from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-gray-300 py-8">
            <div className="max-w-6xl mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

                    <div>
                        <h3 className="text-xl font-bold text-teal-400 mb-4">About Me</h3>
                        <p>
                            Hi, I’m <span className="font-bold">Bheesham</span>, a Front-End
                            Developer dedicated to creating responsive and user-friendly
                            websites. Let’s build something amazing together!
                        </p>
                        <a
                            href="/about"
                            className="text-teal-400 hover:underline mt-2 inline-block"
                        >
                            Learn More →
                        </a>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold text-teal-400 mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <a
                                    href="#home"
                                    className="hover:text-teal-400 transition duration-300"
                                >
                                    Home
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#about"
                                    className="hover:text-teal-400 transition duration-300"
                                >
                                    About
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#portfolio"
                                    className="hover:text-teal-400 transition duration-300"
                                >
                                    Portfolio
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#contact"
                                    className="hover:text-teal-400 transition duration-300"
                                >
                                    Contact
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#blog"
                                    className="hover:text-teal-400 transition duration-300"
                                >
                                    Blog
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold text-teal-400 mb-4">
                            Connect with Me
                        </h3>
                        <p className="mb-2">
                            <FaEnvelope className="inline mr-2" />
                            <a
                                href="mailto:bheeshamkumar@gmail.com"
                                className="hover:text-teal-400"
                            >
                                bheeshamkumar@gmail.com
                            </a>
                        </p>

                        <p className="mb-3 mt-4">
                            <FaPhone className="inline mr-2" />
                            <a
                                href="mailto:+923xx xxx xxxx"
                                className="hover:text-teal-400"
                            >
                                +923x xxx xxxx
                            </a>
                        </p>

                        <div className="flex space-x-4 mt-4">
                            <a
                                href="https://www.linkedin.com/in/bheesham-mm"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-300 hover:text-teal-400 transition duration-300"
                            >
                                <FaLinkedin className="text-2xl" />
                            </a>
                            <a
                                href="https://github.com/Bheesham-mm"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-300 hover:text-teal-400 transition duration-300"
                            >
                                <FaGithub className="text-2xl" />
                            </a>
                            <a
                                href="https://www.facebook.com/profile.php?id=100076744035847"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-gray-300 hover:text-teal-400 transition duration-300"
                            >
                                <FaFacebook className="text-2xl" />
                            </a>
                        </div>

                    </div>
                </div>

                <div className="mt-8 border-t border-gray-700 pt-4 text-center">
                    <p>
                        © {new Date().getFullYear()} <span className="hover:text-teal-400 cursor-pointer">Bheesham</span>. All Rights Reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
